import React, { useEffect, useRef } from "react";
import "assets/scss/helpers/customModal.scss";
import classNames from "classnames";
// import Scrollbar from "react-scrollbars-custom";

const Modal = ({
  modalClass,
  children,
  onClose = false,
  show = null,
  backdropStyle,
}) => {
  const modalRef = useRef(null);
  useEffect(() => {
    if (show) {
      modalRef.current.classList.add("visible");
    }
  }, [show]);

  const modalContentClass = classNames({
    modal: true,
    [modalClass]: modalClass && true,
  });

  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        if (onClose) {
          onClose();
        }
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);

    //eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      {show && (
        <div ref={modalRef} style={backdropStyle} className="modal__wrap">
          <div className={modalContentClass}>{children}</div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Modal;
